import { render } from "./PromoComponent.vue?vue&type=template&id=6d8e04a6"
import script from "./PromoComponent.vue?vue&type=script&lang=js"
export * from "./PromoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__